/**
 * SectionGlow — an ambient, sunlit depth layer for a `.pg-section`.
 * Renders two slowly-drifting soft orbs (brand teal + champagne gold) behind
 * the section content. Decorative only (aria-hidden); motion is frozen under
 * prefers-reduced-motion via the global rule in index.css.
 */
export const SectionGlow = ({ tone = "warm", className = "" }) => (
    <div className={`pg-glow pg-glow--${tone} ${className}`} aria-hidden="true">
        <span className="pg-glow__orb pg-glow__orb-a" />
        <span className="pg-glow__orb pg-glow__orb-b" />
    </div>
);

export default SectionGlow;
